export const MobileMenuButton = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
        <rect x="8" y="15" width="28" height="3" fill="currentColor" />
        <rect x="8" y="26" width="28" height="3" fill="currentColor" />
    </svg>
}